import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { StepSequencerState } from '@/store/types/step-sequencer.state';

export const getters: GetterTree<StepSequencerState, RootState> = {

};